export function normalizeTotalPoint(totalPoint) {
	const parsedPoint = Number(totalPoint);
	return Number.isFinite(parsedPoint) ? parsedPoint : 0;
}

export function isForcedCheckoutEligible(totalPoint) {
	return normalizeTotalPoint(totalPoint) <= -15;
}